import { useCallback, useState } from 'react';

import { useQuery } from '@tanstack/react-query';
import { useParams } from 'next/navigation';

import { callService } from '@api/remote-call';
import { ListingBannerViewModel } from '@api/v3';
import { useSkipEffectOnMount } from '@hooks/lifecycle';

interface useBannerFetchingProps {
  initialData?: ListingBannerViewModel;
}

export const useListingBannerFetching = ({
  initialData,
}: useBannerFetchingProps) => {
  const [isClientSide, setIsClientSide] = useState(false);
  const params = useParams();
  useSkipEffectOnMount(() => {
    if (params?.slug && !isClientSide) {
      setIsClientSide(true);
    }
  }, [params?.slug]);

  const fetchBannerItems = useCallback(
    () =>
      callService(
        {
          service: 'ContentsService',
          method: 'getListingBanners',
          version: 'v3',
        },
        {
          slug: params?.slug as string,
        }
      ),
    [params?.slug]
  );
  const fetchBanners = () => {
    return fetchBannerItems();
  };
  const { data, isFetching, refetch } = useQuery(
    ['listing', params?.slug],
    fetchBanners,
    {
      enabled: Boolean(params?.slug && isClientSide),
      initialData: initialData,
    }
  );
  return {
    bannerData: data,
    bannerDataIsFetching: isFetching,
    bannerDataRefetch: refetch,
  };
};
